import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BlogService } from '../../../services/blog.service';
import type { BlogPostListItemDto } from '@api/models';
import { onWindowLoad } from '../../../helpers/on-window-load.function';
import { DatePipe, SlicePipe } from '@angular/common';
import { RouterLinkWithLang } from '../../../directives/router-link-with-lang/router-link-with-lang.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { LanguageService } from '../../../services/language/language.service';

@Component({
  selector: 'posts-preview',
  templateUrl: './posts-preview.component.html',
  styleUrls: ['./posts-preview.component.scss'],
  imports: [SlicePipe, DatePipe, TranslatePipe, RouterLink, RouterLinkWithLang],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PostsPreviewComponent implements OnInit {
  private blogService = inject(BlogService);
  private destroyRef = inject(DestroyRef);
  protected languageService = inject(LanguageService);

  readonly category = input<string>(undefined);
  posts = signal<BlogPostListItemDto[]>([]);

  ngOnInit(): void {
    onWindowLoad(() => this.fetchPosts());
  }

  fetchPosts(): void {
    switch (this.category()) {
      case 'lastWorks':
        this.blogService.getPostsList({ categoryId: 3, limit: 3 })
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(response => this.posts.set(response.data));
        break;
      case 'lastPosts':
        this.blogService.getLastPosts()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(response => this.posts.set(response.data));
        break;
    }
  }
}
